export default __webpack_public_path__ + "static/media/bg-5of7.f790de83.svg";